const config = {
  host: process.env.MYSQL_HOST,
  user: process.env.MYSQL_USER,
  password: process.env.MYSQL_PASSWORD,
  database: process.env.MYSQL_DATABASE,
  multipleStatements: true,
  UNAUTHORIZED: false,
  timezone: 'MST',
  env: process.env.NODE_ENV,
  mail: {
    host: 'smtp-mail.outlook.com',
    port: 587,
    auth: {
      user: process.env.MAIL_USERNAME,
      pass: process.env.MAIL_PASSWORD,
    },
  },
  jwt: {
    secret: process.env.MYSQL_PASSWORD,
    expiresIn: '7d',
  },
  otp: {
    // expiry is in milliseconds
    expiryIn: '60000',
  },
};

export default config;
